export const GET_REPORT_SUCCESS = 'reports/GET_REPORT_SUCCESS';
export const GENERATE_REPORT_SUCCESS = 'reports/GENERATE_REPORT_SUCCESS';
export const CLEAR_REPORT = 'reports/CLEAR_REPORT';